import { defineStyleConfig } from '@chakra-ui/system';

export const Alert = defineStyleConfig({
    variants: {
        subtle: (props) => ({
            container: {
                borderColor: `${props.colorScheme || 'green'}.600`,
                borderStyle: 'solid',
                textStyle: 'slt-body-text',
                backgroundColor: 'slt-red.50',
            },
        }),
        error: {
            container: {
                padding: 2,
                textStyle: 'slt-body-text',
                textColor: 'slt-red-error',
                backgroundColor: 'slt-red.50',
            },
        },
        info: {
            container: {
                padding: 2,
                textStyle: 'slt-body-text-lg',
                backgroundColor: 'slt-beige.400',
            },
        },
    },
});
